import React, { useState } from 'react'
import { Row, Col, Card, Button, Alert, Modal } from "react-bootstrap";

import './Redeem.css'
import RedeemSteps from './RedeemSteps';
import RedeemOptions from './RedeemOptions';



const Redeem = () => {
  const [showEmailModal, setShowEmailModal] = useState(true);
  const handleShowEmailModal = () => setShowEmailModal(true);
  const handleCloseEmailModal = () => {
    setShowEmailModal(false);
  };
  return (
    <div className="mt-2">
      <h2 className="page-main-title">Redeem</h2>
      <Alert variant="success" className="email-alert d-flex flex-column flex-md-row justify-content-between align-items-center">
        <div className="text-center text-md-start mb-2 mb-md-0 alert-text">
          Looks like you missed verifying your email account.<br />Hurry! you get 1000 points once you verify.
        </div>
        <Button className="email-alert-btn" onClick={handleShowEmailModal}>Get started</Button>
      </Alert>

      <div className="bg-white p-4 rounded shadow flex gap-4 items-center">
          <RedeemSteps />
      </div>

      <div className="bg-white mt-4 p-4 rounded shadow flex gap-4 items-center">
        <RedeemOptions />
      </div>

    </div>
  )
}

export default Redeem